import React, { useEffect, useState } from "react";
import { AiFillEdit, AiFillDelete, AiOutlinePlus } from "react-icons/ai";
import { decrpt } from "../../component/encryption";
import axios from "axios";
import Cookies from "js-cookie";
import { FormControl, Modal, Form, Button, Badge } from "react-bootstrap";
import Loader from "../../component/loader";

function SettingSlider() {  
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [error, setError] = useState(null);
  const [sliderList, setSliderList] = useState([]);

  // For Edit
  const [sliderSelected, setSliderSelected] = useState({
    id: '',
    image: null,
    heading: '',
    type: 1
  });
  const [sliderPreview, setSliderPreview] = useState('');

  // For Add
  const [addSlider, setAddSlider] = useState({
    heading: '',
    image: null,
    type: 1
  });
  const [newSliderPreview, setNewSliderPreview] = useState('');

  const fetchSliderList = async () => {
    setLoader(true);
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      // Fetch sliders (type: 1)
      const response = await axios.post(`/admin/slider/list`, { type: 1 });
      if (response.data && response.data.data) {
        let items = response.data.data;
        if (items.some(it => it.type !== undefined)) {
          items = items.filter(it => it.type == 1);
        }
        setSliderList(items);
      }
    } catch (err) {
      console.error('Error fetching sliders:', err);
    } finally {
      setLoader(false);
    }
  };

  const sliderStatusUpdate = async (item) => {
    setLoader(true);
    const newstatus = item.status == 1 ? 2 : 1;
    const data = {
      id: item.id,
      status: newstatus
    };
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/slider/status`, data);
      if (response.data && response.data.success) {
        setSliderList(prev => prev.map(s => s.id === item.id ? { ...s, status: newstatus } : s));
      }
    } catch (err) {
      console.error('Error updating status:', err);
      alert('Failed to update status. Please try again.');
    } finally {
      setLoader(false);
    }
  };

  const handleEdit = (item) => {
    setError(null);
    setSliderSelected({
      id: item.id,
      image: null, // Reset to null so we only send a new file if the user uploads one
      heading: item.heading || '',
      type: item.type || 1
    });
    setSliderPreview(item.image || '');
    setShow(true);
  };

  function handlePreview(e) {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSliderPreview(URL.createObjectURL(file));
      setSliderSelected(prev => ({ ...prev, image: file }));
    }
  }

  function handlePreviewadd(e) {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setNewSliderPreview(URL.createObjectURL(file));
      setAddSlider(prev => ({ ...prev, image: file }));
    }
  }

  const sliderUpdate = async (e) => {
    e.preventDefault();
    setLoader(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append("id", sliderSelected.id);
      formData.append("heading", sliderSelected.heading ? sliderSelected.heading : '');
      formData.append("type", 1);
      
      // ONLY append image if a new File was selected!
      if (sliderSelected.image instanceof File) {
        formData.append("image", sliderSelected.image);
      }

      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/slider/save`, formData);
      
      if (response.data && response.data.success) {
        setShow(false);
        fetchSliderList();
      }
    } catch (err) {
      console.error('Error updating slider:', err);
      if (err.response?.data?.errors) {
        const errObj = err.response.data.errors;
        const msg = Object.values(errObj).flat().join(', ');
        setError(msg);
      } else {
        setError(err.response?.data?.message || 'Failed to update slider');
      }
    } finally {
      setLoader(false);
    }
  };

  const slideradd = async (e) => {
    e.preventDefault();
    if (!addSlider.image) {
      alert("Please select an image file for the new slider.");
      return;
    }
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append("image", addSlider.image);
      formData.append("heading", addSlider.heading ? addSlider.heading : '');
      formData.append("type", 1);

      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/slider/save`, formData);

      if (response.data && response.data.success) {
        setAddShow(false);
        setAddSlider({ heading: '', image: null, type: 1 });
        setNewSliderPreview('');
        fetchSliderList();
      }
    } catch (err) {
      console.error('Error adding slider:', err);
      alert(err.response?.data?.message || 'Failed to create slider');
    } finally {
      setLoader(false);
    }
  };

  const sliderDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this slider? This action cannot be undone.")) {
      return;
    }
    setLoader(true);
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/slider/delete`, { id });
      if (response.data && response.data.success) {
        setSliderList(prev => prev.filter(s => s.id !== id));
      } else {
        alert(response.data?.message || 'Could not delete slider');
      }
    } catch (err) {
      console.error('Error deleting slider:', err);
      alert(err.response?.data?.message || 'Failed to delete slider. Ensure backend endpoint is deployed.');
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSliderList(); 
  }, []);

  return (
    <div className="main-content">
      {loader ? (
        <Loader /> 
      ) : (
        <div className="section">
          <div className="card p-3 shadow-sm border-0 rounded-3">
            <div className="card-title d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom flex-wrap gap-2">
              <div>
                <h5 className="mb-0 fw-bold">Website Slider</h5>
                <small className="text-muted">Total: {sliderList?.length || 0} slider{sliderList?.length === 1 ? '' : 's'}</small>
              </div>
              <button 
                className="btn btn-sm btn-primary d-flex align-items-center gap-1 text-white fw-semibold"
                onClick={() => {
                  setAddSlider({ heading: '', image: null, type: 1 });
                  setNewSliderPreview('');
                  setAddShow(true);
                }}
              >
                <AiOutlinePlus size={16} /> Add New Slider
              </button>
            </div>

            <div className="row g-3">
              {sliderList && sliderList.length > 0 ? (
                sliderList.map((item, index) => {
                  const isActive = item.status == 1;
                  return (
                    <div key={index} className="col-lg-3 col-md-4 col-sm-6">
                      <div className="card h-100 border shadow-sm rounded-3 overflow-hidden">
                        <div style={{ position: 'relative', height: 160, backgroundColor: '#f3f4f6' }}>
                          <img 
                            src={item.image} 
                            alt={item.heading || 'Slider'} 
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => { e.target.src = '/folder.png'; }}
                          />
                          <div style={{ position: 'absolute', top: 8, right: 8 }}>
                            {isActive ? (
                              <Badge bg="success" className="px-2 py-1 shadow-sm">Active</Badge>
                            ) : (
                              <Badge bg="secondary" className="px-2 py-1 shadow-sm">Inactive</Badge>
                            )}
                          </div>
                        </div>

                        <div className="card-body p-3 d-flex flex-column justify-content-between">
                          <div>
                            <p className="fw-semibold text-dark mb-2 text-truncate" title={item.heading || 'No Caption'}>
                              {item.heading || <span className="text-muted fst-italic">No Caption</span>}
                            </p>
                          </div>

                          <div className="d-flex align-items-center justify-content-between gap-1 pt-2 border-top mt-2">
                            {isActive ? (
                              <button 
                                className="btn btn-xs btn-outline-danger" 
                                onClick={() => sliderStatusUpdate(item)}
                                title="Click to Disable"
                              >
                                Disable
                              </button>
                            ) : (
                              <button 
                                className="btn btn-xs btn-outline-success" 
                                onClick={() => sliderStatusUpdate(item)}
                                title="Click to Enable"
                              >
                                Enable
                              </button>
                            )}

                            <div className="d-flex gap-1">
                              <button 
                                className="btn btn-xs btn-primary text-white d-flex align-items-center gap-1" 
                                onClick={() => handleEdit(item)}
                                title="Edit Slider"
                              >
                                <AiFillEdit /> Edit
                              </button>
                              <button 
                                className="btn btn-xs btn-danger text-white d-flex align-items-center gap-1"
                                onClick={() => sliderDelete(item.id)}
                                title="Delete Slider"
                              >
                                <AiFillDelete /> Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-12 py-5 text-center text-muted">
                  <p className="mb-0">No sliders found. Click "Add New Slider" to add one.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="h6 fw-bold">Edit Slider</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger py-2 small">{error}</div>}
          <Form onSubmit={sliderUpdate}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Image Caption / Heading</Form.Label>
              <FormControl 
                type="text" 
                value={sliderSelected.heading} 
                onChange={e => setSliderSelected({ ...sliderSelected, heading: e.target.value })} 
                placeholder="Type slider caption..." 
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Replace Image (Optional)</Form.Label>
              <Form.Control type="file" accept="image/*" onChange={handlePreview} />
              <small className="text-muted d-block mt-1">Leave empty to keep the existing image.</small>
            </Form.Group>

            <div className="d-flex w-100 align-items-center justify-content-between pt-2 border-top">
              <div style={{ width: 100, height: 60, borderRadius: 6, overflow: 'hidden', border: '1px solid #ddd' }}>
                <img 
                  src={sliderPreview || '/folder.png'} 
                  alt="Preview" 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="d-flex gap-2">
                <Button variant="secondary" size="sm" onClick={() => setShow(false)}>Cancel</Button>
                <Button variant="primary" size="sm" type="submit">Save Changes</Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Add Modal */}
      <Modal show={addShow} onHide={() => setAddShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="h6 fw-bold">Add New Slider</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={slideradd}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Image Caption / Heading</Form.Label>
              <FormControl 
                type="text" 
                value={addSlider.heading} 
                onChange={e => setAddSlider({ ...addSlider, heading: e.target.value })} 
                placeholder="Type slider caption..." 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Upload Image <span className="text-danger">*</span></Form.Label>
              <Form.Control type="file" accept="image/*" onChange={handlePreviewadd} required />
            </Form.Group>

            <div className="d-flex w-100 align-items-center justify-content-between pt-2 border-top">
              <div style={{ width: 100, height: 60, borderRadius: 6, overflow: 'hidden', border: '1px solid #ddd' }}>
                <img 
                  src={newSliderPreview || '/folder.png'} 
                  alt="Preview" 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="d-flex gap-2">
                <Button variant="secondary" size="sm" onClick={() => setAddShow(false)}>Cancel</Button>
                <Button variant="primary" size="sm" type="submit">Add Slider</Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SettingSlider;
